module.exports = __webpack_public_path__ + "static/media/lock.a29cbfc1.svg";